<template>
  <div class="content">
    <div class="mb20">
      <el-button type="primary" size="small" @click="addextPartner(0)">添加</el-button>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
            prop="avatar"
            label="微信头像"
            >
            <template slot-scope="scope">
	            <img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
	            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
              <p>{{scope.row.nickname}}</p>
	          </template>
          </el-table-column>
        <el-table-column prop="name" label="姓名" ></el-table-column> 
         <el-table-column prop="tel" label="联系方式"></el-table-column>
        <el-table-column prop="discount_text" label="合伙人消费是否优惠"></el-table-column>
        <el-table-column label="方案名称">
            <template slot-scope="scope">
              <el-popover
                      placement="top-start"
                      title="方案名称"
                      trigger="hover">
                <div class="tableline" v-if="scope.row.scheme.length">
                  <div class="list" v-for="(item,index) in scope.row.scheme" :key="index">
                    <span>{{item.name}}</span>
                    <span>数量：{{item.num}}次</span>
                    <span>已领取{{item.receive_num}}</span>
                  </div>
                </div>
                 <span slot="reference" class="tablelineBtn">关联{{scope.row.scheme_cnt}}方案</span>
              </el-popover>
              <!--<span style="display: block">{{scope.row.others_link_str}}</span>-->
            </template>
          </el-table-column>
        <el-table-column prop="create_time_text" label="创建时间"></el-table-column>
        <el-table-column prop="expire_time_text" label="到期时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="balance" label="充值金额"></el-table-column>  
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addextPartner(1,scope.row.id)">编辑</el-button>
              <el-button
                v-if="scope.row.status===1"
                type="text"
                size="small"
                @click="forbid(scope.row.id)"
              >停用</el-button>
              <el-button
                v-if="scope.row.status===0"
                type="text"
                size="small"
                @click="resume(scope.row.id)"
              >启用</el-button>
              <el-button type="text" size="small" @click="handleBtn(scope.row.id)">删除</el-button> 
              <el-button type="text" size="small" @click="showDiffQr(scope.row.name,scope.row.qrcode)" v-if="!scope.row.nickname">查看二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pag_wrap">
      <el-pagination
          background
          layout="total,prev, pager, next"
          :current-page ='page.current_page'
          :page-size='page.page_size' 
          :pager-count='page.page_count' 
          :page-count="page.total_pages"
          :total="page.total"
          @current-change= "currentChange">
        </el-pagination>
    </div>
    
      <!-- 二维码弹框 -->
    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      :name="name"
      :qrcode="qrcode" 
      width="30%">
     <div style="text-align:center">
      <el-image
          style="width: 200px; height: 200px"
          :src="qrcode"
          ></el-image>
      <p>请将二维码分享给[{{name}}]微信，进行授权绑定</p>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "externalPartner",
  props: ["visible", "name","qrcode"],
  filters: {//限制文本显示字数,超出部分用...代替
    ellipsis (value) {
        if (!value) return ''
        if (value.length > 25) {
          return value.slice(0,25) + '...'
        }
        return value
    },
  },
  data() {
    return {
      tableData: [],
     page: {
        current_page: pagination.current_page,
        page_size: pagination.page_size,
        total_rows: pagination.total_rows
      },
      dialogTableVisible: false,//方案
      dialogVisible:false,//二维码
      schemecordData: [],
      qrResult:{},//二维码结果信息
    }
  },
  created() {
    this.initFn();
  },
  methods: {
    initFn() {
      this.axios
        .post(api.partnerLists, {page: this.page.current_page,type:2})
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result;
            this.page.total = response.data.page.total_rows//总条数
          } 
        })
        .catch(() => {});  
    },
    // 分页
    currentChange(current_page) {
      this.pages.current_page = current_page;
      this.initFn();
    },
    addextPartner(type, id) {
      this.$router.push({name: "addextPartner", query: {type: type, id: id}});
    },

   
    //删除
    handleBtn(id){
      this.$confirm('是否确定进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
              this.axios
              .post(api.partner_del ,{partner_id:id})
              .then(res=>{
                if(res.data.code == 0){
                  this.$message.success(res.data.msg);
                  // this.btnDisabled = false
                  this.initFn();
                }
              }).catch(res => {});
          })
          .catch(() => {
            // this.btnDisabled = false
            this.$message({
                type: 'info',
                message: '您已取消删除'
            });          
        });   
    },
     // 停用
    forbid(id) {
      let params = {
        partner_id: id,
        status: '0',
      };
      this.axios
        .post(api.partner_changeStatus, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "停用成功",
              type: "success"
            });
            this.initFn();
          } else {
          }
        })
        .catch(() => {});
    },
    // 启用
    resume(id) {
      let params = {
        partner_id: id,
        status: '1',
      };
      this.axios
        .post(api.partner_changeStatus, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "启用成功",
              type: "success"
            });
            this.initFn();
          } else {
          }
        })
        .catch(() => {});
    },
    //显示二维码id
    showDiffQr(name,qrcode){
        this.name=name
        this.qrcode=qrcode
        this.dialogVisible= true
        
    },
    
  }
}
</script>